var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-logo",attrs:{"id":"Logo"}},[_c('a',{attrs:{"href":"/"}},[(this.getSiteProps('landingpage.banner'))?_c('img',{attrs:{"src":this.getSiteProps('landingpage.banner'),"alt":"Logo"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }